import { useMemo } from 'react';
import { useLocalizationContext } from '@im/react-localization';
import { NavItem } from '@im/ui-lib/nav';
import { useServicesMenuQuery } from '../../hooks/use-servicesmenu';
import { buildNavMenuItem } from './utils';

export function useServicesNavItems(enabled: boolean) {
  const { locale } = useLocalizationContext();
  const { data: services } = useServicesMenuQuery(locale, enabled);

  return useMemo<NavItem[]>(() => {
    const navMenuItems = buildNavMenuItem(services, locale);

    return navMenuItems;
  }, [locale, services]);
}
